<div fxLayout="column" fxLayoutGap="15px">

    <kendo-formfield>
        <kendo-label text="{{'claims-center.claimDocumentation.proofDocumentType' | translate}}"></kendo-label>
        <kendo-dropdownlist fxFill formControlName="typeId" valuePrimitive="true"
            [data]="proofDocumentTypes$ | async" [textField]="'value'" [valueField]="'id'">
        </kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield >
        <kendo-label text="{{'claims-center.claimDocumentation.proofDocumentKind' | translate}}"></kendo-label>
        <kendo-dropdownlist fxFill formControlName="kindId" valuePrimitive="true"
            [data]="proofDocumentKinds$ | async" [textField]="'value'" [valueField]="'id'">
        </kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield>
        <kendo-label text="{{'claims-center.claimDocumentation.proofDocumentConformity' | translate}}"></kendo-label>
        <kendo-dropdownlist fxFill formControlName="conformityId" valuePrimitive="true"
            [data]="proofDocumentConformities$ | async" [textField]="'value'" [valueField]="'id'">
        </kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield>
        <kendo-label text="{{'claims-center.claimDocumentation.proofDocumentRequiredFrom' | translate}}"></kendo-label>
        <kendo-dropdownlist fxFill formControlName="requiredFrom" valuePrimitive="true"
            [data]="proofDocumentRequiredFromOptions$ | async" [textField]="'value'" [valueField]="'id'">
        </kendo-dropdownlist>
    </kendo-formfield>

    <kendo-formfield>
        <kendo-label text="{{'claims-center.claimDocumentation.description' | translate}}">
        </kendo-label>
        <kendo-textarea fxFill formControlName="description" rows="5" width="auto"></kendo-textarea>
    </kendo-formfield>

</div>
